/**
 * Small bridge components that sync React state into the module-level
 * telemetry store. Mirrors the pattern in docs/skills/telemetry/SKILL.md
 * section 9 (context access pattern).
 *
 * `TelemetrySync` updates user_id whenever the auth state changes.
 * `TelemetryPageTracker` updates screen_name on every route change and
 * fires `page_viewed`.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/AuthContext'
import { Telemetry, setCurrentScreen, setTelemetryContext } from '@/lib/telemetry'

export function TelemetrySync() {
  const { user } = useAuth()

  useEffect(() => {
    setTelemetryContext({
      userId: user?.id ?? 'anonymous',
      orgId: user?.orgId ?? 'none',
    })
  }, [user?.id, user?.orgId])

  return null
}

export function TelemetryPageTracker() {
  const location = useLocation()

  useEffect(() => {
    setCurrentScreen(location.pathname)
    Telemetry.pageViewed({ screen_name: location.pathname })
  }, [location.pathname])

  return null
}
